import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles, Drawer, Button, ButtonGroup } from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import { ViewModule as ViewModuleIcon, AssignmentInd as AssignmentIndIcon, TableChart as TableChartIcon, Settings as SettingsIcon, KeyboardArrowLeft as LeftIcon, Autorenew as RenewIcon } from '@material-ui/icons';
import GridView from './GridView/GridView'
import CardView from './CardView/CardView'
import TableView from './TableView/TableView'
import SettingView from './SettingView/SettingView'
import { Info as InfoIcon } from "@material-ui/icons"
import withAuthorized from "../../../With/withAuthorized"
import { Redirect } from 'react-router-dom';
import InfoPanel from '../../../InfoPanel/InfoPanel';
import SpriteManager, { SpriteDefine } from '../../../Character/SpriteManager';

import  * as Lambda from "../../../../Lambda";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        margin: "8px",
    },
    background: {
        position: "fixed",
        zIndex: -1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    content: {
        padding: 0,
        borderRadius: "10px",
        minHeight: "calc(100vh - 200px)",
    },
    toolbarContainer: {
        display: "flex",
        justifyContent: "center",
    },
    toolbar: {
        margin: 8,
        backgroundColor: "#FFF",
    },
    spacer: {
        flexGrow: 1
    },
  }),
);


const infoPanelWidth = 256;
const infoPanelStyles =  makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: infoPanelWidth,
      height: "100vh",
      zIndex: theme.zIndex.appBar - 1,
      paddingTop: 56, 
      paddingBottom: 56,
      [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: { 
        paddingTop: 48, 
        paddingBottom: 48,
      }, 
      [theme.breakpoints.up('sm')]: { 
        paddingTop: 64, 
        paddingBottom: 64,
      },
    }
  })
);


interface Props {
    roomId: string
}

interface ThemeType {
    id: string
    url: string
    bkcolor: string
}

function Room(props: Props) {

    const classes = useStyles()
    const infoPanelClasses = infoPanelStyles()

    const [mode, setMode] = useState("grid")
    const [size, setSize] = useState("medium")

    const [linkTo, setLinkTo] = useState<string|undefined>()
    
    const [room, setRoom] = useState<Lambda.RoomType | undefined>()
    useEffect(()=>{
        const func = async()=>{
            try {
                const response = await Lambda.getRoom({id: props.roomId})
                if (response) {
                    response.members = await Lambda.getRoomMembers({roomId: props.roomId})
                } 
                setRoom(response)
                console.log(response)
                setLastModified(response.lastModified)
            } 
            catch (e){
               setLinkTo("/404/")
            }
        }
        func()
    },[props.roomId])
    
    const [spriteManager, setSpriteManager] = React.useState<SpriteDefine | undefined>();

    const [theme, setTheme] = useState<{[key:string]: ThemeType}>({})
    useEffect(()=>{
        const func = async ()=>{
            const response = await fetch("/Theme/Theme.json")
            if (response.ok){
                setTheme(await response.json())
            }
        }
        func()
    },[])

    const [infoPanel, setInfoPanel] = useState(true)

    const [notification, setNotification] = useState<any[]>([])
    const [lastModified, setLastModified] = useState<string | undefined>()
    const [time, setTime] = useState(Date.now());
    
    useEffect(() => {
        const func = async () => {
            if (lastModified) {
                const response = await Lambda.queryNotifications({
                    resource: "rooms",
                    id: props.roomId,
                    lastModified: lastModified
                })
                setLastModified(response.lastModified)
                
                // update members 
                const memberIds = response.notifications
                    .filter(notification=>notification.code === "MEMBER_UPDATE")
                    .map(notification=>notification.resourceId)
                if (memberIds.length !== 0) {
                    const members = await Lambda.getRoomMembers({
                        roomId: props.roomId,
                        memberIds: memberIds,
                    })
                    let arr = room?.members || []
                    console.log(members)
                    console.log(arr)
                    for (const member of members) {
                        console.log(arr.findIndex(element=>element.id === member.id))
                        arr.splice(arr.findIndex(element=>element.id === member.id), 1, member)
                    }
                    setRoom(room ? {...room, members: arr} : undefined)
                }

                setNotification([...notification, ...response.notifications])
            }
        }
        func()
    }, [time]); 

    useEffect(()=>{
        const func = async () => {
            setTime(Date.now())
        }
        const interval = setInterval(func, 1000 * 60 * 10)
        return ()=>{
            console.log("Cancel Interval")
            clearInterval(interval)
        }
    }, [])

    return (
        <div className={classes.root}> 
            <SpriteManager ready={(sm)=>setSpriteManager(sm)} />
            <div style={infoPanel? {paddingRight: infoPanelWidth} : {}}>
                <div className={classes.background} style={{backgroundImage: theme?.[room?.theme || "default"]?.url}}>

                </div>
                <div className={classes.toolbarContainer}>
                    <ButtonGroup 
                        size="small"
                        className={classes.toolbar}>
                        <Button onClick={()=>setLinkTo("/")}><LeftIcon /></Button>
                    </ButtonGroup>

                    <ButtonGroup 
                        size="small"
                        className={classes.toolbar}>
                        <Button onClick={()=>setTime(Date.now())}><RenewIcon /></Button>
                    </ButtonGroup>

                    <ToggleButtonGroup
                        value={mode}
                        exclusive
                        onChange={(e,v)=>v ? setMode(v) : null}
                        size="small"
                        className={classes.toolbar}
                    >
                        <ToggleButton value="grid" aria-label="grid view">
                            <ViewModuleIcon />
                        </ToggleButton>
                        <ToggleButton value="card" aria-label="card view">
                            <AssignmentIndIcon />
                        </ToggleButton>
                        <ToggleButton value="table" aria-label="table view">
                            <TableChartIcon />
                        </ToggleButton>
                        <ToggleButton value="setting" aria-label="setting view">
                            <SettingsIcon />
                        </ToggleButton>
                    </ToggleButtonGroup>

                    <ToggleButtonGroup
                        value={size}
                        exclusive
                        onChange={(e,v)=>v ? setSize(v) : null}
                        size="small"
                        className={classes.toolbar}
                    >
                        <ToggleButton value="small" aria-label="small">
                            S
                        </ToggleButton>
                        <ToggleButton value="medium" aria-label="medium">
                            M
                        </ToggleButton>
                        <ToggleButton value="large" aria-label="large">
                            L
                        </ToggleButton>
                    </ToggleButtonGroup>

                    <span className={classes.spacer} />

                    {
                        infoPanel ? null : 
                        <ButtonGroup 
                            size="small"
                            className={classes.toolbar}>
                            <Button onClick={()=>setInfoPanel(!infoPanel)}><InfoIcon /></Button>
                        </ButtonGroup>
                    }
                </div>
                <div className={classes.content} style={ {backgroundColor: theme?.[room?.theme || "default"]?.bkcolor} }>
                    { mode === "grid" ? <GridView sprite={spriteManager} room={room} size={size} /> : null }
                    { mode === "card" ? <CardView sprite={spriteManager} room={room} size={size} /> : null }
                    { mode === "table" ? <TableView sprite={spriteManager} room={room} /> : null }
                    { mode === "setting" ? <SettingView room={room} setRoom={setRoom} /> : null }
                </div>
            </div>            
            <Drawer open={infoPanel} variant="persistent" anchor="right" classes={infoPanelClasses}>
                <InfoPanel onClose={()=>{setInfoPanel(false)}} />
            </Drawer>   
            {
                linkTo ? (<Redirect to={linkTo} />) : null
            }
        </div>
    )
}

export default withAuthorized<Props>(Room)